export const computeDealerType = (info, marketType) => {
    var _a;
    const type = (_a = info.dealerType) !== null && _a !== void 0 ? _a : 'FULLSTACK';
    if (marketType !== 'commercial') {
        switch (type) {
            case 'FULLSTACK':
                return 'HS';
            case 'SERVICE_ONLY':
                return 'WS';
            case 'SALES_ONLY':
                return 'HN';
        }
        // handle unknown type without failing
        return 'HS';
    }
    // commercial
    switch (type) {
        case 'FULLSTACK':
            return 'HSB';
        case 'SERVICE_ONLY':
            return 'WS';
        case 'SALES_ONLY':
            return 'HNB';
        case 'TRADEPORT':
            return 'NVB';
    }
    // handle unknown type without failing
    return 'HSB';
};
